export enum Client_Event_Name {
	ping = 'ping',
	start_player_registration = 'start_player_registration',
	start_host_trial_registration = 'start_host_trial_registration',
	start_host_registration = 'start_host_registration',
	register_player = 'register_player',
	toggle_trial = 'toggle_trial',
	verify = 'verify',
	add_team = 'add_team',
	join_team = 'join_team',
	buzz = 'buzz',
	test_buzz = 'test_buzz',
	clear_buzz = 'clear_buzz',
	turn_on_buzzer = 'turn_on_buzzer',
	leave_game = 'leave_game',
	get_player_status = 'get_player_status',
	player_reconnect = 'player_reconnect',
	reset_game = 'reset_game',
	quit = 'quit',
	clear_error = 'clear_error',
	confirm_cancel_game = 'confirm_cancel_game',
	dismiss_modal = 'dismiss_modal',
	navigate_back = 'navigate_back',
	cancel_game = 'cancel_game',
	buy_games = 'buy_games',
	cancel_purchase = 'cancel_purchase',
	send_feedback = 'send_feedback',
}

export enum Host_Event_Name {
	register_host = 'register_host',
	register_host_with_payment = 'register_host_with_payment',
	register_trial_host = 'register_trial_host',
	purchase_full_game = 'purchase_full_game',
	resume_game = 'resume_game',
	setup_game_structure = 'setup_game_structure',
	client_side_error = 'client_side_error',
	get_host_status = 'get_host_status',
	remove_team = 'remove_team',
	setup_game = 'setup_game',
	set_teams_enabled = 'set_teams_enabled',
	add_sample_questions = 'add_sample_questions',
	toggle_trivia_subject = 'toggle_trivia_subject',
	add_round = 'add_round',
	add_custom_round = 'add_custom_round',
	add_question = 'add_question',
	swap_questions = 'swap_questions',
	swap_rounds = 'swap_rounds',
	remove_round = 'remove_round',
	remove_question = 'remove_question',
	get_trivia_topics = 'get_trivia_topics',
	choose_trivia_topic = 'choose_trivia_topic',
	start_game = 'start_game',
	save_and_exit = 'save_and_exit',
	set_question_text = 'set_question_text',
	set_answer_text = 'set_answer_text',
	set_question_points = 'set_question_points',
	set_question_deduct_points = 'set_question_deduct_points',
	update_game_structure = 'update_game_structure',
	answer_is_correct = 'answer_is_correct',
	answer_is_incorrect = 'answer_is_incorrect',
	skip_question = 'skip_question',
	finish_round = 'finish_round',
	finish_game = 'finish_game',
	remove_player = 'remove_player',
	change_team_score = 'change_team_score',
	change_player_score = 'change_player_score',
	return_to_setup = 'return_to_setup',
	close_game = 'close_game',
	navigate_back = 'navigate_back',
}

export enum Server_Event_Name {
	pong = 'pong',
	game_server_created = 'game_server_created',
	trial_timeout = "trial_timeout",
	game_update = 'game_update',
	host_update = 'host_update',
	host_resume_update = 'host_resume_update',
	game_structure_update = 'game_structure_update',
	send_trivia_subjects = 'send_trivia_subjects',
	game_setup_unverified = 'game_setup_unverified',
	game_in_setup = 'game_in_setup',
	game_started = 'game_started',
	request_resume_game = 'request_resume_game',
	request_resume_verification = 'request_resume_verification',
	game_expired = 'game_expired',
	game_returned_to_setup = 'game_returned_to_setup',
	game_already_exists_for_host = 'game_already_exists_for_host',
	game_saved = 'game_saved',
	game_finished = 'game_finished',
	game_closed = 'game_closed',
	invalid_message = 'invalid_message',
	verification_code_incorrect = 'verification_code_incorrect',
	verify_and_continue = 'verify_and_continue',
	player_name_already_exists = 'player_name_already_exists',
	player_registered = 'player_registered',
	host_registered = 'host_registered',
	player_buzzed = 'player_buzzed',
	game_doesnt_exist = 'game_doesnt_exist',
	server_event_error = 'server_event_error',
	player_removed = 'player_removed',
	buzzer_test = 'buzzer_test',
	socket_disconnected = 'socket_disconnected',
	feedback_received = 'feedback_received',
}

export enum Server_State_Name {
	/** state where the machine initialised but nothing has happened yet */
	init = 'init',
	/** state where the game is initialised but the host hasn't verified by email yet */
	unverified = 'unverified',
	/** state where the host needs to purchase more full games */
	has_run_out_of_games = 'has_run_out_of_games',
	/** state before the game starts where the host is inviting players in and setting up teams */
	pre_game_setup = 'pre_game_setup',
	/** state where game is in play */
	in_play = 'in_play',
	/** state after the game has finished */
	finished = 'finished',
	/** ready to be destroyed */
	closed = 'closed',
}

export interface Feedback_Event {
	type: Client_Event_Name.send_feedback,
	detail: {
		client_name: 'web' | 'react-native',
		user_type: 'host' | 'player',
		game_code: string,
		is_trial: boolean,
		rounds_played: number,
		usable_rating: number,
		problem_free_rating: number,
		looks_nice_rating: number,
		feedback_comments: string,
	},
}

export function is_feedback_event(obj: any): obj is Feedback_Event {
	return obj && obj.type === Client_Event_Name.send_feedback && typeof obj.detail === 'object'
}